import * as $account from './_account'
import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $childaccounts from './account.childaccounts'

export interface IInitOptions {
    pageName: string;
    pagePrefix: string;
}

var options:IInitOptions;

export function init($options:IInitOptions) : void {
    options = $.extend(true, {}, $options);

    elemid("newsave").click(function () {
        var email:string = elemid("newemail").val();
        var password:string = elemid("newpassword").val();

        $ajax.post({
            loadingText: "Skapar konto...",
            url: "/Account/ChildAccountsCreate",
            data: {
                email: email,
                password: password
            },
            success: function (res) {
                if (res.Ok) {
                    $msg.show(res.Message);
                    $childaccounts.getList();
                    $childaccounts.editModal(res.Guid);
                } else {
                    $msg.showError(res.Message);
                }
            }
        });
    });

    elem("tbl-row-edit").click(function () {
        var id:string = $(this).attr("data-id");
        $childaccounts.editModal(id);
    });

    elem("tbl-row-delete").click(function () {
        var id:string = $(this).attr("data-id");
        var name:string = $(this).attr("data-name");

        if (!confirm(`Är du säker på att du vill radera ${name}?`)) return;

        $ajax.post({
            loadingText: "Raderar konto...",
            url: "/Account/ChildAccountsDelete",
            data: {
                id: id
            },
            success: function (res) {
                if (res.Ok) {
                    $childaccounts.getList();
                } else {
                    $msg.showError(res.Message);
                }
            }
        });
    });
}

function elem(id:string) : JQuery {
    return $(`.${options.pagePrefix}-${id}`);
}

function elemid(id:string) : JQuery {
    return $(`#${options.pagePrefix}-${id}`);
}